import { TestimonialCard, SuccessCard } from './SuccessStories';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const RelatedStories = ({ relatedPosts, deviceType }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 3.5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 679 },
      items: 1.5,
    },
    mobile: {
      breakpoint: { max: 678, min: 0 },
      items: 1,
    },
  };
  return (
    <>
      <h1 className="my-10 text-center lg:text-left">Related Stories</h1>
      <div className="mx-14 lg:mx-0">
        <Carousel
          swipeable={true}
          draggable={true}
          responsive={responsive}
          arrows={true}
          ssr={true} // means to render carousel on server-side.
          // infinite={true}
          partialVisible={true}
          itemClass="slider-crousel"
          keyBoardControl={true}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
          deviceType={deviceType}
          dotListClass="owl-dots"
          showDots={true}
        >
          {relatedPosts.data.map((item, index) => (
            <>
              {!item.attributes.videoLink ? (
                <TestimonialCard
                  key={index}
                  item={item}
                  bgColor={
                    index % 2 === 0
                      ? '#DDF4EF'
                      : // : index % 3 === 0
                        // ? "#FBEAEA"
                        '#F8ECDE'
                  }
                />
              ) : (
                <SuccessCard key={index} item={item} />
              )}
            </>
          ))}
        </Carousel>
      </div>
    </>
  );
};

export default RelatedStories;
